function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import utils from '../../../common/utils/index.js';
import window from '../../../common/window/windowWrapper';
import { GalleryComponent } from '../../galleryComponent';

var GalleryDebugMessage = /*#__PURE__*/function (_GalleryComponent) {
  _inheritsLoose(GalleryDebugMessage, _GalleryComponent);

  var _super = _createSuper(GalleryDebugMessage);

  function GalleryDebugMessage() {
    return _GalleryComponent.apply(this, arguments) || this;
  }

  var _proto = GalleryDebugMessage.prototype;

  _proto.render = function render() {
    if (utils.getTopUrlParam('pgdebug') !== 'true') {
      return false;
    }

    var version = /*#__PURE__*/React.createElement("div", {
      className: "version-header "
    }, "Pro Gallery Version #", window.staticsVersion);
    var parentSize = '';

    try {
      parentSize = ' psw' + window.top.screen.width + ' piw' + window.top.innerWidth + ' pbw' + window.top.document.body.clientWidth;
    } catch (e) {//not on the domain
    }

    var debugMsg = /*#__PURE__*/React.createElement("div", {
      className: "version-header "
    }, utils.isLandscape() ? 'land' : 'port', " sw", window.screen.width, "sh", window.screen.height, " iw", window.innerWidth, " bw", window.document.body.clientWidth, " sr", '1', "rc", this.props.resizeCount, " oc", this.props.orientationCount, " nh", this.props.newHeight, " lh", this.props.lastHeight, parentSize, "www", this.props.maxGalleryWidth);
    return /*#__PURE__*/React.createElement("div", null, version, debugMsg);
  };

  return GalleryDebugMessage;
}(GalleryComponent);

export default GalleryDebugMessage;